export default {
	footer: {
		ageRestriction: "Our platform is for users aged 18 and over only. Gambling can be addictive. Please play responsibly and only for entertainment. For more information, visit our Responsible Gaming page.",
		followUs: "FOLLOW US",
		company: "COMPANY",
		legal: "LEGAL",
		support: "SUPPORT",
		gameProviders: "GAME PROVIDERS",
		copyright: "Copyright © 2019-2026 LOGO. All Rights Reserved.",
		documents: "Documents",
	}
}